(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[261,8545],{

/***/ 88545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Addons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81380);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);



function Addons(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "https://kit.fontawesome.com/3c7cbada9c.js",
                crossOrigin: "anonymous",
                async: true
            }),
            props.hasOwnProperty("script_sections") ? props.script_sections != null ? props.script_sections.map(function(section, key) {
                return(// section.app_section_content
                section.app_section_content != null ? !section.app_section_content.includes("platform") ? section.app_section_content.split("<script>")[1] != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: section.app_section_content.split("<script>")[1].split("</script>")[0],
                    defer: true
                }, key) : "" : "" : "");
            }) : "" : ""
        ]
    });
}


/***/ }),

/***/ 56951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11101);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83974);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31969);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23158);








function BuilderHead(props) {
    var isRateParityWebAppPage = props.hasOwnProperty("isRateParityWebAppPage") ? props.isRateParityWebAppPage : false;
    var manifestPath = "/manifest.json";
    if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].booleanState */ .Z.booleanState(props.property)) {
        manifestPath = "../../" + manifestPath.split("/")[1];
    }
    var showRateParityWidget = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_general_show_rateparity_widget") == 1 ? true : false;
    });
    var seoRobotsInstructions = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_search_engine_instuctions");
    });
    var showCookieYes = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_enable") == 1 ? true : false;
    });
    var cookiesYesIdentifier = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_head_cookies_cookieyes_identifier");
    });
    var cookiesYesScript = function() {
        if (_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(cookiesYesIdentifier)) {
            return "https://cdn-cookieyes.com/client_data/" + cookiesYesIdentifier + "/script.js";
        }
        return null;
    };
    var rateParityHasLoaded = function() {
        if (true) {
            return document.getElementById("rp-allinone");
        }
        return true;
    };
    var cookieYesHasLoaded = function() {
        if (true) {
            return document.getElementsByClassName("cky-preference-center").length > 0;
        }
        return true;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (props.font != null) {
            var head = document.getElementsByTagName("head")[0];
            var style = document.createElement("style");
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            switch(props.font){
                case "Roboto Slab":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Serif":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto+Slab:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', serif !important}";
                    break;
                case "Roboto":
                    link.href = "https://fonts.googleapis.com/css?family=Roboto:300,400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', sans-serif !important}";
                    break;
                case "Vollkorn":
                    link.href = "https://fonts.googleapis.com/css?family=Vollkorn:400,600,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Vollkorn', serif !important}";
                    break;
                case "Noto Sans":
                    link.href = "https://fonts.googleapis.com/css?family=Noto+Sans:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Noto Sans', sans-serif !important}";
                    break;
                case "Cousine":
                    link.href = "https://fonts.googleapis.com/css?family=Cousine:400,700&amp;subset=greek&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Roboto Slab', monospace !important}";
                    break;
                case "Playfair":
                    link.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&display=swap";
                    style.innerText = "h1,h2,h3,h4,h5,h6,.font-montserrat{font-family: 'Playfair Display', serif !important}";
                    break;
                default:
                    link.href = "https://fonts.googleapis.com/icon?family=Material+Icons&display=swap";
                    break;
            }
            head.appendChild(link);
            head.appendChild(style);
        }
    });
    var googleSchema = {
        "@context": "https://schema.org/",
        "@type": "Organization",
        "name": "".concat(props.googleSchemaTitle),
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "".concat(props.googleSchemaStreetAddress),
            "addressLocality": "".concat(props.googleSchemaCity),
            "addressRegion": "".concat(props.googleSchemaCountry),
            "postalCode": "".concat(props.googleSchemaZip)
        },
        "telephone": "".concat(props.googleSchemaPhone)
    };
    var absoluteUrl = function(url) {
        if (!_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(url)) return null;
        if (/^https?:\/\//i.test(url)) return url;
        var isLocal = /(^|\.)(localhost|local)(:\d+)?(\/|$)/i.test(url);
        return (isLocal ? "http://" : "https://") + url.replace(/^\/+/, "");
    };
    var canonicalUrl = absoluteUrl(props.seoUrl);
    var pageUrl = canonicalUrl || props.domain;
    var pageSchema = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.image_fb_meta) ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        "@context": "https://schema.org/",
        "@type": "WebPage",
        "name": props.title
    }, pageUrl ? {
        "url": pageUrl
    } : {}), {
        "primaryImageOfPage": {
            "@type": "ImageObject",
            "url": props.image_fb_meta
        },
        "image": props.image_fb_meta
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }),
            props.keywords != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                content: props.titleOfficial
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(seoRobotsInstructions) ? seoRobotsInstructions : "index, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "theme-color",
                content: props.designColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "referrer",
                content: "strict-origin"
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            props.icon_60 != null && props.icon_60 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: props.icon_60
                    })
                ]
            }),
            props.icon_76 != null && props.icon_76 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: props.icon_76
            }),
            props.icon_120 != null && props.icon_120 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: props.icon_120
            }),
            props.icon_152 != null && props.icon_152 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: props.icon_152
            }),
            props.icon_256 != null && props.icon_256 != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/x-icon",
                        href: props.icon_256
                    })
                ]
            }),
            props.icon != null && props.icon != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: props.icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-touch-fullscreen",
                content: "yes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "place"
            }),
            props.manager == false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:type",
                content: "place"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: props.site_name_fb_meta + " | " + props.title_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isValidString */ .Z.isValidString(props.desc_fb_meta) ? props.desc_fb_meta : props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: props.desc_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: props.image_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.image_fb_meta
            }),
            props.image_fb_meta_width != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: String(props.image_fb_meta_width)
            }),
            props.image_fb_meta_height != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: String(props.image_fb_meta_height)
            }),
            props.lat_fb_meta != null && props.lat_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:latitude",
                content: props.lat_fb_meta
            }) : null,
            props.lon_fb_meta != null && props.lon_fb_meta != "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "place:location:longitude",
                content: props.lon_fb_meta
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: pageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: props.site_name_fb_meta
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image:alt",
                content: props.twitter_img_alt
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(googleSchema)
                }
            }),
            pageSchema && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(pageSchema)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "manifest",
                href: manifestPath
            }),
            !cookieYesHasLoaded() && showCookieYes && cookiesYesScript != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: "cookieyes",
                type: "text/javascript",
                src: cookiesYesScript(),
                defer: true
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            !rateParityHasLoaded() && !isRateParityWebAppPage && showRateParityWidget ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "text/javascript",
                    src: "https://code.rateparity.com/versions/installer.min.js",
                    defer: true
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BuilderHead);


/***/ }),

/***/ 90261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Articles; }
});

// EXTERNAL MODULE: ../../shared/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(14140);
// EXTERNAL MODULE: ../../shared/node_modules/react/index.js
var react = __webpack_require__(89736);
// EXTERNAL MODULE: ../../shared/node_modules/next/dynamic.js
var dynamic = __webpack_require__(18256);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./helpers/class/Checkers.ts
var Checkers = __webpack_require__(83974);
// EXTERNAL MODULE: ./components/Addons.tsx
var Addons = __webpack_require__(88545);
// EXTERNAL MODULE: ./components/head/BuilderHead.tsx
var BuilderHead = __webpack_require__(56951);
// EXTERNAL MODULE: ./components/templates/articles/ArticleCategoriesContainer.tsx
var ArticleCategoriesContainer = __webpack_require__(18630);
;// CONCATENATED MODULE: ./components/templates/articles/Sections.tsx




function Sections(props) {
    var referer = props.referer;
    var app_data = props.app_data;
    var app = props.app;
    var head = props.head;
    var navigation = props.navigation;
    var locations = props.locations;
    var footer = props.footer;
    var contactIcons = props.contactIcons;
    var isDesktop = props.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.content.hasOwnProperty("htmlCode") && Checkers/* default.isValidString */.Z.isValidString(props.content.htmlCode) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: props.content.htmlCode
                }
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCategoriesContainer/* default */.Z, {
                app_data: props.app_data,
                app: props.app,
                builder: props.builder,
                type: props.type,
                content: props.content,
                isDesktop: isDesktop,
                articlesCategories: props.articlesCategories,
                includeJumbotron: true,
                itemClassName: "experience-design-box"
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/templates/articles/index.tsx







var Scripts = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
function Articles(props) {
    var domain = props.domain;
    var app_data = props.app_data;
    var app = props.app;
    var builder = props.builder;
    var head = props.head;
    var footer = props.footer;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var articlesCategories = props.articlesCategories;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var title = "";
    var titleFbMeta = "";
    var descFbMeta = "";
    var twitter_img_alt = "";
    var imageFbMeta = "";
    var keywords = head.data.meta_keywords;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    var urlHref = props.urlHref;
    title = content.title;
    title += Checkers/* default.isValidString */.Z.isValidString(content.subtitle) ? " - " + content.subtitle : "";
    title += " | " + head.data.title;
    titleFbMeta = content.title;
    descFbMeta = Checkers/* default.objChildExists */.Z.objChildExists(content, "description") ? content.description : Checkers/* default.isValidString */.Z.isValidString(content.subtitle) ? content.subtitle : "";
    twitter_img_alt = content.title;
    twitter_img_alt += Checkers/* default.isValidString */.Z.isValidString(content.subtitle) ? " - " + content.subtitle : "";
    imageFbMeta = Checkers/* default.isValidArray */.Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    var getValue = function(obj, keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (Checkers/* default.objChildExists */.Z.objChildExists(obj, key) && Checkers/* default.isValidString */.Z.isValidString(obj[key])) {
                    return obj[key];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    };
    var metaTitle = getValue(content, [
        "metaTitle",
        "meta_title"
    ]);
    if (metaTitle) {
        titleFbMeta = metaTitle;
        twitter_img_alt = metaTitle;
    }
    var metaDesc = getValue(content, [
        "metaDesc",
        "meta_desc"
    ]);
    if (metaDesc) {
        descFbMeta = metaDesc;
    }
    var metaKeywords = getValue(content, [
        "metaKeywords",
        "meta_keywords"
    ]);
    if (metaKeywords) {
        keywords = metaKeywords;
    }
    if (props.isArticle) {
        descFbMeta = content.description.replace(/(<([^>]+)>)/gi, "");
        imageFbMeta = Checkers/* default.isValidArray */.Z.isValidArray(content.images) && Checkers/* default.isValidString */.Z.isValidString(content.images[0].image) ? content.images[0].image : null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderHead/* default */.Z, {
                title: title,
                keywords: props.type == "blog" && Checkers/* default.isValidString */.Z.isValidString(props.app.blogMetaKeywords) ? props.app.blogMetaKeywords : keywords,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                seoUrl: content.urlSlug ? props.domain + "/" + content.urlSlug : null,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: props.type == "blog" && Checkers/* default.isValidString */.Z.isValidString(props.app.blogMetaTitle) ? props.app.blogMetaTitle : titleFbMeta,
                desc_fb_meta: props.type == "blog" && Checkers/* default.isValidString */.Z.isValidString(props.app.blogMetaDescription) ? props.app.blogMetaDescription : descFbMeta,
                image_fb_meta: imageFbMeta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: twitter_img_alt,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location.address,
                googleSchemaCity: head.location.city,
                googleSchemaCountry: head.location.country,
                googleSchemaZip: head.location.zip,
                googleSchemaPhone: head.location.phone,
                designColor: app.designColor,
                font: app.font,
                manager: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sections, {
                type: props.type,
                isBlogArticle: props.isBlogArticle,
                isDesktop: isDesktop,
                app_data: app_data,
                app: app,
                head: head,
                navigation: navigation,
                locations: locations,
                contactIcons: contactIcons,
                content: content,
                articlesCategories: articlesCategories,
                footer: footer,
                builder: builder,
                htmlSections: props.htmlSections
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Addons["default"], {})
        ]
    });
}


/***/ }),

/***/ 81380:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88512)


/***/ })

}]);